import { render, staticRenderFns } from "./sportstadium.vue?vue&type=template&id=793d6394&scoped=true"
import script from "./sportstadium.vue?vue&type=script&lang=js"
export * from "./sportstadium.vue?vue&type=script&lang=js"
import style0 from "./sportstadium.vue?vue&type=style&index=0&id=793d6394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793d6394",
  null
  
)

export default component.exports